import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import Live from "../../../../../assets/images/instagram-live 1.png";
import Pending from "../../../../../assets/images/pending 2.png";
import Add from "../../../../../assets/images/UpcomingEvent/add 1.png";
import "./MeetUpEventNave.css";

const MeetUpEventNave = () => {
  const [liveCount, setLiveCount] = useState([]);
  const [pendingCount, setPendingCount] = useState([]);

  useEffect(() => {
    axios.get(`/api/admin/meetup_event/live`).then((res) => {
      if (res.status === 200) {
        setLiveCount(res.data.count);
      }
    });
    axios.get(`/api/admin/meetup_event/pending`).then((res) => {
      if (res.status === 200) {
        setPendingCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <div className=" row ">
        <div
          title="Live Now"
          className="col-md-2 align-items-center justify-content-center Souvenir-bt "
        >
          <div className="card meetupCard">
            <div className="card-body  align-items-center">
              <center>
                <tr>
                  <td className="ad-card-td">
                    <img src={Live} className="ad-card-img-top" alt="..." />
                  </td>
                  <td className="ad-card-td">
                    <small className="ad-card-small">{liveCount}</small>
                  </td>
                </tr>
              </center>
            </div>
            <Link to="/superstar-admin/meetup-events/live">
              <button
                className="card-footer Souvenir-button  w-100 "
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                {" "}
                Approved Meet Up
              </button>
            </Link>
          </div>
        </div>

        <br />

        <div
          title="Live Now"
          className="col-md-2 align-items-center justify-content-center Souvenir-bt "
        >
          <div className="card meetupCard">
            <div className="card-body  align-items-center">
              <center>
                <tr>
                  <td className="ad-card-td">
                    <img src={Pending} className="ad-card-img-top" alt="..." />
                  </td>
                  <td className="ad-card-td">
                    <small className="ad-card-small">{pendingCount}</small>
                  </td>
                </tr>
              </center>
            </div>
            <Link to="/superstar-admin/meetup-events/pending">
              <button
                className="card-footer Souvenir-button  w-100 "
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                {" "}
                Pending Meet Up
              </button>
            </Link>
          </div>
        </div>
        <div
          title="Live Now"
          className="col-md-2 align-items-center justify-content-center Souvenir-bt "
        >
          <div className="card meetupCard">
            <div className="card-body  align-items-center">
              <center>
                <tr>
                  <td className="ad-card-td">
                    <img src={Add} className="ad-card-img-top" alt="..." />
                  </td>
                  <td className="ad-card-td">
                    <small className="ad-card-small"></small>
                  </td>
                </tr>
              </center>
            </div>
            <Link to="/superstar-admin/meetup-events/create">
              {" "}
              <button
                className="card-footer Souvenir-button  w-100 "
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                {" "}
                Add Meet Up
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default MeetUpEventNave;
